jQuery('img , video, iframe').removeClass('lazyloaded, lazyload');
